import {BASE_URL} from "@/utils/config";

const URL = BASE_URL;

export const getAdmins = async (axiosInstance, familyTreeId) => {
	try {
		const response = await axiosInstance.get(`${URL}/family-tree/admins/${familyTreeId}`);
		return response.data;
	} catch (error) {
		console.error("Error fetching admins:", error);
		return {success: false};
	}
};

export const addAdmin = async (axiosInstance, data) => {
	try {
		const response = await axiosInstance.post(`${URL}/family-tree/admins/add`, data);
		return response.data;
	} catch (error) {
		console.error("Error adding admin:", error);
		return {success: false};
	}
};

export const removeAdmin = async (axiosInstance, data) => {
	try {
		const response = await axiosInstance.put(`${URL}/family-tree/admins/remove`, data);
		return response.data;
	} catch (error) {
		console.error("Error removing admin:", error);
		return {success: false};
	}
};

export const updateAdminRole = async (axiosInstance, data) => {
	try {
		const response = await axiosInstance.put(`${URL}/family-tree/admins/update-role`, data);
		return response.data;
	} catch (error) {
		console.error("Error updating admin role:", error);
		return {success: false};
	}
};

export const checkAdminStatus = async (axiosInstance, familyTreeId, accountId) => {
	try {
		const response = await axiosInstance.get(
			`${URL}/family-tree/admins/check/${familyTreeId}/${accountId}`
		);
		return response.data;
	} catch (error) {
		console.error("Error checking admin status:", error);
		return {success: false};
	}
};